import { ReactNode } from 'react'
import { RequestEventStatisticsPage } from '../../../../pages/portal/requestEventStatistics'
import { PortalHomePage } from './index'
import { OcrSettingsPage } from './ocrSettings'

type PortalRoute = {
  path: string
  element: ReactNode
}

export const portalRoutes: PortalRoute[] = [
  {
    path: '/portal',
    element: <PortalHomePage />,
  },
  {
    path: '/portal/request-event-statistics',
    element: <RequestEventStatisticsPage />,
  },
  // Melphinでは採用薬の一時変更登録は非表示
  // {
  //   path: '/portal/med_change',
  //   element: <MedChangePage />,
  // },
  {
    path: '/portal/ocr-settings',
    element: <OcrSettingsPage />,
  },
  // Melphinでは表示処理設定は非表示
  // {
  //   path: '/portal/display-settings',
  //   element: <DisplaySettingsPage />,
  // },
]
